import React, { useEffect } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { usePostHog } from 'posthog-js/react';
import MonkeybookWidgetFooter from '../MonkeybookWidgetFooter';
import { WidgetThemeProvider } from '../orderPage/theme/Theme';
import { monkeybookStandardTheme } from '../orderPage/theme/monkeybookTheme';
import { safeStartSessionRecording } from '../utils/safePosthog';
import { ManageBookingWizard } from './ManageBookingWizard';
import { phoneMediaQuery } from './rescheduleTheme';

export const ManageBookingPage = () => {
  const posthog = usePostHog();
  const isPhone = useMediaQuery(phoneMediaQuery);
  useEffect(() => {
    safeStartSessionRecording(posthog);
  }, [posthog]);
  return (
    <WidgetThemeProvider remoteThemeOverride={monkeybookStandardTheme}>
      <Grid container justifyContent="center" sx={{ background: monkeybookStandardTheme.palette.background }}>
        <Grid container flexDirection="column" sx={{ maxWidth: 760 }} p={isPhone ? 1.25 : 0} pt={isPhone ? 1.25 : 3}>
          <ManageBookingWizard />
          <Grid item mt={1}>
            <MonkeybookWidgetFooter languages={[]} />
          </Grid>
        </Grid>
      </Grid>
    </WidgetThemeProvider>
  );
};
